
export class DivisionCategoryItem {
  public id: number;
  public code: string;
  public name: string;
  public limitedToDiscipline: number[];



  constructor(rawCategoryItem: any) {
    this.id = rawCategoryItem.Id;
    this.code = rawCategoryItem.Code;
    this.name = rawCategoryItem.Name;
    this.limitedToDiscipline = rawCategoryItem.LimitedToDiscipline;

  }


}